import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Color } from '../../../../../../chess/types'
import { useScreenSize } from '../../../../../../sharedComponents/src/hooks/useScreenSize'

interface ClaimedRewardProps {
    myColor?: Color
    winner?: Color
    rewardURL?: string
}

const ClaimedReward: React.FC<ClaimedRewardProps> = ({ myColor, winner, rewardURL }) => {
    const { isMobile } = useScreenSize()

    if (myColor !== winner || !rewardURL) {
        return null
    }

    return (
        <Stack gap={1} direction="row" justifyContent="center" alignItems="center">
            <Typography variant={isMobile ? 'h6' : 'h5'} color="secondary" sx={{ textTransform: 'uppercase' }}>
                Reward claimed:
            </Typography>
            <img
                src={rewardURL}
                alt="Featured bot reward"
                style={{
                    height: '32px',
                }}
            />
        </Stack>
    )
}

export default ClaimedReward
